import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom'
import styles from './styles';
import { withStyles } from '@material-ui/core';
import cs from 'classnames';
import Input from './components/Input';
import ResendLinkAlert from './components/ResendLinkAlert/ResendLinkAlert';
import { useForm } from 'react-hook-form';

const SignInForm = ({ classes, value = {}, error = {}, onSubmit, onResend, className, setError }) => {
  const reason = !error.unconfirmed && error.reason;
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const navigate = useNavigate();


  const forgotPass = useCallback(async () => {
    navigate('/forgot-password', {replace: true})
  }, []);

  return (
    <form
      className={cs(className, classes.root)}
      onSubmit={handleSubmit(onSubmit)}
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', maxWidth: '280px' }}
    >
      <p className={classes.title}>Sign In</p>
      {error.unconfirmed && <ResendLinkAlert message={error.reason} onResend={onResend} />}
      <div className={classes.fields} style={{ width: '100%' }}>
        <div className={classes.field} style={{ marginBottom: 4 }}>
          <Input
            name={'email'}
            error={errors.email || reason}
            ref={register({
              required: 'Email is required',
              pattern: { value: /^\s*\S+@\S+\.\S+\s*$/, message: 'Enter a valid email' },
            })}
            autoComplete={'username'}
            defaultValue={value.email}
            label={'Email:'}
            onChange={(e) => {return errors.email || error.reason ? setError() : null}}
          />
          {errors.email && <span className={classes.error}>{errors.email.message}</span>}
          {reason && <span className={classes.error}>{reason}</span>}
        </div>

        <div className={classes.field}>
          <Input
            name={'password'}
            error={errors.password || reason}
            ref={register({ required: true })}
            autoComplete={'current-password'}
            defaultValue={value.password}
            label={'Password:'}
            type={'password'}
            onChange={(e) => {return errors.password || error.reason ? setError() : null}}
          />
          {errors.password && <span className={classes.error}>Password is required</span>}
        </div>
        <p className={classes.forgotText} onClick={forgotPass}>
          Forgot password?
        </p>
      </div>
      <button className={classes.submitBtn} type={'submit'}>
        Sign In
      </button>
    </form>
  );
};

export default withStyles(styles)(SignInForm);
